const GeneralInformationPage = () => import('@/pages/insights/GeneralInformationPage');
const PersonProfilePage = () => import('@/pages/insights/PersonProfilePage');
const ProjectsPage = () => import('@/pages/insights/project/ProjectsPage');
const ProjectPage = () => import('@/pages/insights/project/ProjectPage');
const TeamMembersPage = () => import('@/pages/insights/TeamMembersPage');
const EmikaWorkflowsPage = () => import('@/pages/insights/EmikaWorkflowsPage');
const EmikaSkillsPage = () => import('@/pages/insights/EmikaSkillsPage');
const InvitesManagementPage = () => import('@/pages/insights/InvitesManagementPage');
const IntegrationsManagementPage = () => import('@/pages/insights/IntegrationsManagementPage');
const BillingInformationPage = () => import('@/pages/insights/BillingInformationPage');

export default [
  {
    path: '/insights/general_information',
    component: GeneralInformationPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/members/:profile_id/:edit?',
    component: PersonProfilePage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/projects',
    component: ProjectsPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/project/:project_id',
    component: ProjectPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/members',
    component: TeamMembersPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/emika_workflows',
    component: EmikaWorkflowsPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/emika_skills',
    component: EmikaSkillsPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/invites_management',
    component: InvitesManagementPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/integrations_management',
    component: IntegrationsManagementPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/insights/billing_information',
    component: BillingInformationPage,
    meta: {
      layout: 'InsightsLayout',
    },
  },
];
